/** Casca de bloco da Geral: mesma seção (raio 18, padding 22) dos blocos de gráfico do resto do sistema. */
import type { ReactNode } from 'react';
import { v } from '@/components/v2/theme';

export function Block({ title, sub, right, note, children, padding = 22 }: {
    title: string;
    sub?: ReactNode;
    right?: ReactNode;
    /** Nota de rodapé do bloco — o que o número não diz sozinho. */
    note?: ReactNode;
    children: ReactNode;
    padding?: number;
}) {
    return (
        <section style={{ background: v('surface'), border: `1px solid ${v('border')}`, borderRadius: 18, overflow: 'hidden' }}>
            <div style={{ padding, display: 'flex', flexDirection: 'column', gap: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, marginRight: 'auto', minWidth: 0 }}>
                        <h2 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>{title}</h2>
                        {sub && <span style={{ fontSize: 11.5, color: v('faint') }}>{sub}</span>}
                    </div>
                    {right}
                </div>
                {children}
            </div>
            {note && (
                <p style={{ margin: 0, padding: '11px 18px', borderTop: `1px solid ${v('border-soft')}`, background: v('inset'), fontSize: 11.5, color: v('muted'), lineHeight: 1.55 }}>
                    {note}
                </p>
            )}
        </section>
    );
}
